var heroData = {
    hello:"Hi, my name is",
    name:"Edouard Mignien",
    title1:"I'm a",
    title2:" Software Engineer",
}

exports.heroData = heroData